import React from 'react';
import { string, bool, shape } from 'prop-types';
import styled from 'styled-components';
import { C_LUNAR, C_SHADOW, C_EBON, C_METAL } from '@bbc/psammead-styles/colours';
import { GEL_SPACING_TRPL, GEL_SPACING } from '@bbc/gel-foundations/spacings';
import { getSansRegular, getSansBold } from '@bbc/psammead-styles/font-styles';
import { GEL_BODY_COPY } from '@bbc/gel-foundations/typography';
import { BBC_BLOCKS } from '@bbc/psammead-assets/svgs';
var GOLDEN_RATIO_PERCENT = '38.2%';
var BBC_BLOCKS_WIDTH = '10rem';
var FAUX_BBC_BLOCKS_SPACE = '6rem';
var FILL_VIEWPORT_STYLES = "\n  background-position: center;\n  background-size: ".concat(GOLDEN_RATIO_PERCENT, ";\n  height: 100vh;\n");
var StyledEmbedError = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledEmbedError",
  componentId: "sc-1oc1egd-0"
})(["", " ", ";background-color:", ";background-image:url(data:image/svg+xml;base64,", ");background-position:center ", ";background-repeat:no-repeat;background-size:", ";color:", ";display:flex;flex-direction:column;justify-content:flex-end;padding-top:", ";padding-bottom:", ";border:0.0625rem solid transparent;", ""], function (_ref) {
  var service = _ref.service;
  return getSansRegular(service);
}, GEL_BODY_COPY, C_LUNAR, BBC_BLOCKS, GEL_SPACING_TRPL, BBC_BLOCKS_WIDTH, C_SHADOW, FAUX_BBC_BLOCKS_SPACE, GEL_SPACING_TRPL, function (_ref2) {
  var fillViewport = _ref2.fillViewport;
  return fillViewport && FILL_VIEWPORT_STYLES;
});
var StyledErrorMessage = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledErrorMessage",
  componentId: "sc-1oc1egd-1"
})(["margin:0 ", ";strong{font-weight:normal;}a{", " color:", ";display:block;margin-top:", ";text-decoration:none;&:visited{color:", ";}&:hover,&:focus{text-decoration:underline;}}"], GEL_SPACING_TRPL, function (_ref3) {
  var service = _ref3.service;
  return getSansBold(service);
}, C_EBON, GEL_SPACING, C_METAL);

var EmbedError = function EmbedError(_ref4) {
  var service = _ref4.service,
      message = _ref4.message,
      fillViewport = _ref4.fillViewport,
      link = _ref4.link;
  return /*#__PURE__*/React.createElement(StyledEmbedError, {
    service: service,
    fillViewport: fillViewport
  }, /*#__PURE__*/React.createElement(StyledErrorMessage, {
    service: service
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, message)), link && link.text && link.href && /*#__PURE__*/React.createElement("a", {
    href: link.href
  }, link.text)));
};

EmbedError.defaultProps = {
  service: 'news',
  fillViewport: false,
  link: null
};
EmbedError.propTypes = {
  service: string,
  fillViewport: bool,
  message: string.isRequired,
  link: shape({
    text: string.isRequired,
    href: string.isRequired
  })
};
export default EmbedError;